module.exports = __webpack_public_path__ + "static/assets/9172264a24247609bfe4e7cb10380007.png";